import { __assign } from 'tslib';
import * as React from 'react';
import { UitkIcon } from 'uitk-react-icons';
import { classNames, analyticsTracker, liveAnnounce, Level } from 'uitk-react-utils';
import styles from './uitk-pill.css';
import { useLocalization } from '@shared-ui/localization-context';

var getClassNameList$3 = classNames.bind(styles);
var UitkTriggerPill = function (props) {
    var _a;
    var active = props.active, children = props.children, className = props.className, disabled = props.disabled, icon = props.icon, id = props.id, name = props.name, onClick = props.onClick, selected = props.selected, toggleState = props.toggleState;
    var baseClassName = 'uitk-pill';
    var buttonClassName = getClassNameList$3(baseClassName + " " + baseClassName + "-content", className, (_a = {},
        _a[baseClassName + "-trigger-toggle-state"] = toggleState,
        _a[baseClassName + "-active"] = active,
        _a[baseClassName + "-disabled"] = disabled,
        _a[baseClassName + "-selected"] = selected,
        _a));
    return (React.createElement("button", { id: id, name: name, type: "button", onClick: onClick, disabled: disabled, className: buttonClassName, "aria-expanded": toggleState },
        icon && React.createElement(UitkIcon, { className: getClassNameList$3(baseClassName + "-icon"), name: icon }),
        React.createElement("span", { className: getClassNameList$3(baseClassName + "-text") }, children),
        React.createElement(UitkIcon, { name: "expand_more", className: getClassNameList$3(baseClassName + "-trigger-icon") })));
};
UitkTriggerPill.displayName = 'UitkTriggerPill';

var getClassNameList$2 = classNames.bind(styles);
var UitkPill = function (props) {
    var _a, _b;
    var active = props.active, altText = props.altText, children = props.children, checked = props.checked, className = props.className, disabled = props.disabled, icon = props.icon, id = props.id, name = props.name, onChange = props.onChange, onClick = props.onClick, selected = props.selected, triggerPill = props.triggerPill, toggleState = props.toggleState;
    var triggerPillProps = {
        active: active,
        children: children,
        className: className,
        disabled: disabled,
        icon: icon,
        id: id,
        name: name,
        onClick: onClick,
        selected: selected,
        toggleState: toggleState
    };
    var baseClassName = 'uitk-pill';
    var wrapperClassName = getClassNameList$2(baseClassName, className, (_a = {},
        _a[baseClassName + "-disabled"] = disabled,
        _a));
    var pillContentClassName = getClassNameList$2(baseClassName + "-content", (_b = {},
        _b[baseClassName + "-active"] = active,
        _b[baseClassName + "-selected"] = selected,
        _b));
    return triggerPill ? (React.createElement(UitkTriggerPill, __assign({}, triggerPillProps))) : (React.createElement("div", { className: wrapperClassName },
        React.createElement("input", { id: id, name: name, checked: checked, "aria-checked": checked, type: "checkbox", onChange: onChange, className: getClassNameList$2(baseClassName + "-standard is-visually-hidden"), disabled: disabled, value: "" + checked }),
        React.createElement("label", { className: pillContentClassName, htmlFor: id, "aria-label": altText },
            icon && React.createElement(UitkIcon, { className: getClassNameList$2(baseClassName + "-icon"), name: icon }),
            React.createElement("span", { className: getClassNameList$2(baseClassName + "-text") }, children))));
};
UitkPill.defaultProps = {
    checked: false
};
UitkPill.displayName = 'UitkPill';

var _this = undefined;
var getClassNameList$1 = classNames.bind(styles);
var UitkRemovablePill = function (props) {
    var _a;
    var active = props.active, a11yRemoveText = props.a11yRemoveText, altText = props.altText, analytics = props.analytics, children = props.children, className = props.className, disabled = props.disabled, icon = props.icon, id = props.id, name = props.name, onClick = props.onClick, buttonRef = props.buttonRef;
    var baseClassName = 'uitk-pill';
    var l10n = useLocalization();
    var handleClick = function (evt) {
        if (a11yRemoveText) {
            liveAnnounce(a11yRemoveText, Level.POLITE);
        }
        onClick(evt);
    };
    var wrapperClassName = getClassNameList$1(baseClassName + " " + baseClassName + "-removable " + baseClassName + "-content", className, (_a = {},
        _a[baseClassName + "-disabled"] = disabled,
        _a[baseClassName + "-active"] = active,
        _a));
    var ariaLabel = '';
    if (altText) {
        ariaLabel = altText;
    }
    else {
        ariaLabel = l10n.formatText('remove') + " " + children;
    }
    return (React.createElement("button", { id: id, name: name, onClick: handleClick, onClickCapture: analytics && analyticsTracker.bind(_this, analytics), className: wrapperClassName, type: "button", disabled: disabled, "aria-label": ariaLabel, ref: buttonRef },
        icon && React.createElement(UitkIcon, { className: getClassNameList$1(baseClassName + "-icon"), name: icon }),
        React.createElement("span", { className: getClassNameList$1(baseClassName + "-text") }, children),
        React.createElement(UitkIcon, { className: getClassNameList$1(baseClassName + "-action-icon"), name: "close" })));
};
UitkRemovablePill.displayName = 'UitkRemovablePill';

var getClassNameList = classNames.bind(styles);
var UitkPillContainer = function (props) {
    var _a;
    var children = props.children, className = props.className, wrap = props.wrap;
    var baseClassName = 'uitk-pill-container';
    var wrapperClassName = getClassNameList(baseClassName, className, (_a = {},
        _a[baseClassName + "-wrap"] = wrap,
        _a));
    return React.createElement("div", { className: wrapperClassName }, children);
};
UitkPillContainer.displayName = 'UitkPillContainer';

export { UitkPill, UitkPillContainer, UitkRemovablePill, UitkTriggerPill };
